
import { Component, Vue } from "vue-property-decorator";
//import DeviceVue from "./Device.vue";
import FinderVue from "@/finder/Finder.vue";

import { IDevice, Dict } from "@/device/IDevice";

import Bus from "@/lib/Bus"
const bus: Bus = new Bus().getBus();
import  ButtonVue from "@/lib/Button.vue";
import UploaderVue from "@/uploader/Uploader.vue";
import { IDeviceSvc, device_api } from "@/device/IDeviceSvc";
import { DeviceSvc } from "@/device/DeviceSvc";
import { Next, Route } from 'vue-router';
import { Debouncer } from "@/lib/Debouncer";

@Component({ async beforeRouteEnter(to: Route, from: Route, next: Next<DeviceVue>) {
            console.log("********************* beforeRouteEnter:", to.path, to.params.device_id )
            next((vm: DeviceVue) => { vm.id = to.params.device_id  });
        },
        components: { ButtonVue, FinderVue} 
        })

export default class DeviceVue extends Vue {

  id:string="";
  _id:string="";
  device: IDevice|undefined=undefined;
  key=0;
  new_labels=0;
  deviceSvc=new DeviceSvc()
  dict=new Dict()
  debounced:any

  async chg() {
    if (!this.debounced) return;
    await this.debounced();
  }
  
  async _chg() {
    if (!this.device) return;

    if (this.device.rodzaj=="MASZYNY DRUKUJĄCE") {
        for (let i=0;i<this.dict.maszyny.length;i++) {
          if (this.dict.maszyny[i].nr_maszyny==this.device.nr_maszyny) {
            this.device.idn=this.dict.maszyny[i].nazwa_maszyny;
          }
        }
    }

    if (this.device.rodzaj=="PRZEWIJARKI") {
        for (let i=0;i<this.dict.przewijarki.length;i++) {
          if (this.dict.przewijarki[i].nr_maszyny==this.device.nr_maszyny) {
            this.device.idn=this.dict.przewijarki[i].nazwa_maszyny;
          }
        }
    }

    console.log("device:chg")
    const device =  await this.deviceSvc.update(this.device)
    if (device && device.version) {
      this.device.version = device.version;
    }
    this.key++;
  }


async refresh() {

      console.log("refresh using id", this.id);
      const l = await this.deviceSvc.find_by_id( this.id );
      if (l) {
        if (!l.counter_faktor) l.counter_faktor=1
        if (!l.counter_base) l.counter_base=0
        this.device = l;
        this.key++;
      }
}


 async del_device(l: IDevice) {
    if (confirm("Na pewno skasować urządzenie "+l.idn+"?")) {
      const device = await this.deviceSvc.delete(l);
    }
  }


  async mounted() {
    console.log('device mounted', this.id)
    this.debounced = Debouncer.debounce(await (this._chg.bind(this)), 1000).bind(this);
    await this.refresh();
  }

}
